import {get, cloneDeep, omit, intersection} from 'lodash'
import createModel from 'utils/model'
import {search, getExternalUserIds} from 'app-self-support-order/services/customer'
import {getShopList} from 'app-self-support-order/services/shop-manage'
import constants from 'common/constants'

function parseAmount(amount) {
    return typeof amount === 'number' ? amount * 100 : undefined
}

function parseNumber(number) {
    return typeof number === 'number' ? number : undefined
}

function getBody(query) {
    const copy = cloneDeep(query)
    if (copy.ordertime) {
        copy.create_min = copy.ordertime[0]
            ? `${copy.ordertime[0].format(constants.dateFormat)} 00:00:00`
            : undefined
        copy.create_max = copy.ordertime[1]
            ? `${copy.ordertime[1].format(constants.dateFormat)} 23:59:59`
            : undefined
    }

    if (copy.amount) {
        // 单位分
        const {amount} = copy
        copy.amount_min = parseAmount(amount[0])
        copy.amount_max = parseAmount(amount[1])
    }

    if (copy.order_num) {
        const {order_num: orderNum} = copy
        copy.order_num_min = parseNumber(orderNum[0])
        copy.order_num_max = parseNumber(orderNum[1])
    }

    if (copy.goods_num) {
        const {goods_num: goodsNum} = copy
        copy.good_num_min = parseNumber(goodsNum[0])
        copy.good_num_max = parseNumber(goodsNum[1])
    }

    return omit(copy, ['amount', 'order_num', 'goods_num', 'ordertime', 'limit', 'offset'])
}

export default createModel({
    namespace: 'selfSupportOrder_customer',
    state: {
        tableData: {},
        checkAll: false, // 全选
        allIds: [], // 筛选出的全部客户的external_userid
        selectedIds: [], // 选中的客户external_userid
        shops: [],
    },

    subscriptions: {},

    effects: {
        // eslint-disable-next-line no-unused-vars
        *search(_, {select, call, put}) {
            const {tableData, checkAll} = yield select(
                ({selfSupportOrder_customer}) => selfSupportOrder_customer,
            )

            const query = {
                offset: tableData.pagination.pageSize * (tableData.pagination.current - 1),
                limit: tableData.pagination.pageSize,
                ...tableData.params,
            }

            const body = getBody(query)

            const res = yield call(search, {
                body,
                params: {
                    offset: tableData.pagination.pageSize * (tableData.pagination.current - 1),
                    limit: tableData.pagination.pageSize,
                },
            })

            if (res && res.data) {
                if (checkAll) {
                    yield put({
                        type: 'getExternalUserIds',
                        payload: {body},
                    })
                }
            }
            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    draft.tableData.dataSource = res?.data || []
                    draft.tableData.pagination.total = get(res, 'pagination.rows_found', 0)
                },
            })
            return res
        },

        // eslint-disable-next-line no-unused-vars
        *getExternalUserIds({payload}, {call, select, put}) {
            const {tableData, selectedIds} = yield select(
                ({selfSupportOrder_customer}) => selfSupportOrder_customer,
            )
            if (!payload) {
                payload = {body: getBody(tableData.params)}
            }

            const res = yield call(getExternalUserIds, payload)

            if (res) {
                const data = res.data || []
                yield put({
                    type: 'immerCb',
                    payload: (draft) => {
                        draft.allIds = data
                    },
                })
                if (selectedIds.length) {
                    // 交集
                    const newSelectedIds = intersection(data, selectedIds)
                    yield put({
                        type: 'immerCb',
                        payload: (draft) => {
                            draft.selectedIds = newSelectedIds
                        },
                    })
                }
            }
            return res
        },

        // 获取店铺列表
        // eslint-disable-next-line no-unused-vars
        *getShopList(xxx, {put, call}) {
            const res = yield call(getShopList, {offset: 0, limit: 10000})

            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    draft.shops = res.data
                },
            })
        },
    },

    reducers: {},
})
